import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

OrderLogItemSubstitution.propTypes = {
  logItem: PropTypes.object,
  orderItem: PropTypes.object,
  items: PropTypes.array,
  setHighlightedRow: PropTypes.func,
  change: PropTypes.object,
}
export default function OrderLogItemSubstitution({ logItem, orderItem, items, setHighlightedRow, change }) {
  const replacedWithOrderItem = items.find(i => i.id?.toString() === change.newValue);
  return (
    <>
      <Typography variant="caption" sx={{ textDecoration: 'underline', cursor: 'pointer'}} onClick={() => setHighlightedRow(logItem.itemQuantityId)}>
      {`Item ${orderItem?.description} | ${orderItem?.vendorItemId}`}
      </Typography> replaced with 
      <Typography variant="caption" sx={{ textDecoration: 'underline', cursor: 'pointer'}} onClick={() => setHighlightedRow(replacedWithOrderItem?.id)}>
        {` ${replacedWithOrderItem?.description || ''} | ${replacedWithOrderItem?.vendorItemId || ''}`}
      </Typography>
    </>
  );
}